import React from "react";
import Header from "../SharedComponents/Header/Header";
import { withLocation } from "../SharedComponents/withLocation";
import { Box, Button, Typography, Link, CircularProgress } from "@mui/material";
import { Location, NavigateFunction, Link as RouterLink } from "react-router-dom";
import { withNavigationHooks } from "../SharedComponents/withNavigationHooks";
import { FinishScreenController, FinishScreenControllerDelegate } from "./controller";
import { environment } from "../utils/environment";
import LoginGuard from "../SharedComponents/LoginGuard/loginGuard";

interface State {
  error: {};
  data: {
    allowFeedback: boolean;
    feedbackToken: string;
    instrumentId: string;
    assignmentId: number;
  }
  isLoading: boolean;
}

interface Props {
  locationHooks: Location;
  navigationHooks: NavigateFunction;
}

class Finish extends React.Component<Props, State> implements FinishScreenControllerDelegate {
  controller: FinishScreenController;
  constructor(props: Props) {
    super(props);
    this.controller = new FinishScreenController(this);
    this.state = {
      error: {
      },
      data: {
        allowFeedback: false,
        feedbackToken: '',
        instrumentId: this.props.locationHooks.state.data.instrumentId,
        assignmentId: this.props.locationHooks.state.data.assignmentId,
      },
      isLoading: false
    };
  }

  componentDidMount(): void {
    this.controller.getAllowFeedback(
      localStorage.getItem("AccessToken")!,
      this.state.data.instrumentId
    )
  }

  // Controller Delegate

  applicationShouldLogout() { };
  genericError() { };
  didGetAllowFeedback(allowFeedback: boolean) {
    const newState = { ...this.state };
    newState.data.allowFeedback = allowFeedback;
    this.setState(newState, () => {
      const token = localStorage.getItem("AccessToken")!;
      this.controller.getAssignmentFeedbackToken(token, this.state.data.assignmentId);
    });
  };

  didGetAssignmentToken(token: string): void {
    this.setState({
      data: {
        ...this.state.data,
        feedbackToken: token
      },
      isLoading: false
    });


  }

  didClickSeeResults() {
    const fullUrl = `${environment.feedbackBaseUrl}?jwt=${this.state.data.feedbackToken}`;
    window.open(fullUrl, '_blank');
  }

  // Internals

  renderLoading() {
    return (
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        marginTop={2}
      >
        <CircularProgress />
      </Box>
    );
  }

  renderResultsButton() {
    return (
      <Button
        component={Link}
        onClick={() => this.didClickSeeResults()}
        variant="contained"
        sx={{
          borderRadius: 10,
          marginTop: 4,
          width: {
            xs: 300,
            sm: 300,
            md: 300
          },
          alignSelf: "center"
        }}
      >
        <Typography color="white" variant="button">
          Ver Devolutiva
        </Typography>
      </Button>
    )
  }

  renderFinalScreen() {
    const title = this.props.locationHooks.state.data.instrumentTitle;
    const firstTimeFinished = this.props.locationHooks.state.data.firstTimeFinished;
    const shouldShowResults = this.state.data.allowFeedback;
    return (
      <Box display="flex" flexDirection="column" width="100%" alignItems="center" justifyContent="center">
        <Box
          alignItems="center"
          display="flex"
          flexDirection="column"
          marginTop={5}
          marginX={10}
        >
          <Typography variant="h5">
            {
              firstTimeFinished ?
                "APLICAÇÃO FINALIZADA!" :
                "Teste já respondido"
            }
          </Typography>
          <Typography variant="h3" color="primary" marginY={4}>
            {title}
          </Typography>
          {shouldShowResults && this.renderResultsButton()}
          <Button
            component={RouterLink}
            to="/"
            variant="contained"
            sx={{
              borderRadius: 10,
              marginTop: 4,
              width: {
                xs: 300,
                sm: 300,
                md: 300
              },
              alignSelf: "center"
            }}
          >
            <Typography color="white" variant="button">
              Responder outro teste
            </Typography>
          </Button>
        </Box>
      </Box>
    )
  }

  render() {
    return (
      <Box display="flex" flexDirection="column" width="100%" alignItems="center" justifyContent="center">
        <LoginGuard />
        <Header logoutEnabled={true} />
        {this.state.isLoading ? this.renderLoading() : this.renderFinalScreen()}
      </Box>
    )
  }
}

export default withNavigationHooks(
  withLocation(
    Finish
  )
);